import styled from 'styled-components'
import { Link } from 'react-router-dom'

import Container from 'components/Container/Container'

export const AppHeader = styled.header<{ isStiky: boolean }>`
  padding: 2.124rem 0 1.5rem;
  background-color: ${({ theme }) => theme.colors.white};
  width: 100%;
  top: 0;
  left: 0;
  position: fixed;
  z-index: 15;
  ${({ isStiky }) =>
    isStiky &&
    `
    box-shadow: 0 0.25rem 0.5rem rgb(152 152 152 / 10%);
  `}
`
export const AppHeaderContainer = styled(Container)``
export const AppHeaderContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
`
export const AppHeaderLogo = styled.img`
  max-width: 8.35rem;
  z-index: 2;
  cursor: pointer;
`
export const AppHeaderNav = styled.nav`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
`
export const AppHeaderMenu = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  align-items: center;
`
export const AppHeaderMenuItem = styled.li`
  margin-right: 3rem;
  &:last-child {
    margin: 0;
  }
`
export const AppHeaderMenuLink = styled(Link)`
  font-size: 0.875rem;
  line-height: 0.875rem;
  text-decoration: none;
  color: ${({ theme }) => theme.colors.blackSecondary};
  transition: all 0.25s ease-in;
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`
export const AppHeaderActions = styled.div`
  z-index: 2;
`

export const AppHeaderControlContainer = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
  position: relative;
  height: 50px;
`
export const AppHeaderControlIcon = styled.img``
export const AppHeaderControlUsername = styled.span`
  display: inline-block;
  margin-left: 1.25rem;
`
export const AppHeaderControlAvatar = styled.img`
  margin-left: 1.25rem;
  width: 35px;
  height: 35px;
  overflow: hidden;
  border-radius: 50%;
`
export const AppHeaderControlDropDown = styled.div`
  position: absolute;
  top: 2.5rem;
  left: 0;
  right: 0;
`
export const AppHeaderControlMenu = styled.div`
  position: absolute;
  top: 0.5rem;
  left: 0;
  right: 0;
  max-width: fit-content;
  margin: 0 auto;
  padding: 1.25rem 0.812rem 1rem;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  z-index: 3;
  &::before {
    content: '';
    position: absolute;
    border-left: 1rem solid transparent;
    border-right: 1rem solid transparent;
    border-bottom: 1rem solid ${({ theme }) => theme.colors.white};
    margin: 0 auto;
    left: 0;
    right: 0;
    top: -11px;
    width: 0;
  }
`
export const AppHeaderControlDropDownTriangle = styled.div`
  position: absolute;
  width: 1rem;
  height: 1rem;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.primary};
  transform: rotate(45deg);
  margin: 0 auto;
  left: 0;
  right: 0;
  top: 0rem;
`

export const AppHeaderControlLink = styled(Link)`
  font-size: 0.725rem;
  line-height: 0.725rem;
  text-decoration: none;
  margin: 0 0 1rem;
  transition: all 0.25s ease-in;
  &:last-child {
    margin: 0;
  }
  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }
`

export const AppHeaderAuthContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
